/** OCR识别-上传发票文件*/
export const API_TICKET_OCR_UPLOAD = {
  url: 'invoice/ocr/identifyInvoice',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/** OCR识别-查询OCR识别结果*/
export const API_TICKET_OCR_RESULT = {
  url: 'invoice/ocr/invoiceDetailByOCR',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/** OCR识别-查验发票 */
export const API_TICKET_OCR_CHECK = {
  url: 'invoice/ocr/invoiceCheck',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**电子签章图片上传功能*/
export const API_POST_UPLOAD = {
  url: 'signData/upload',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/**根据勾票单号获取OCR发票list*/
export const API_TICKET_OCR_LIST = {
  url: 'checkticket/selectOcrByCheckTicketNo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
/**获取发票其他文件list*/
export const API_TICKET_ATTACHMENT_LIST = {
  url: 'checkticket/selectByCheckTicketNo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
/** OCR保存发票附件和发票 */
export const API_TICKET_OCR_SAVE = {
  url: 'invoice/ocr/saveOCRInvoice',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/**保存发票上传信息-新版，同时保存OCR和附件发票*/
export const API_TICKET_OTHER_SAVE = {
  url: 'checkticket/addCheckTicketFile',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/**同时保存OCR和附件发票*/
export const API_TICKET_OCR_AND_OTHER_SAVE = {
  url: 'checkticket/newSaveBatchCheckTicketFile',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/**删除OCR发票文件*/
export const API_TICKET_OCR_DELETE = {
  url: 'invoice/ocr/deleteOCRInvoiceFile',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/**删除其他附件文件*/
export const API_TICKET_ATTACHMENT_DELETE = {
  url: 'checkticket/cancelById',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
